import React, { useState } from 'react';

export default function RenameConfigModal({ onClose, onRename, currentName, existingNames }) {
  const [newName, setNewName] = useState(currentName);
  const [showOverwriteConfirm, setShowOverwriteConfirm] = useState(false);

  const handleRename = () => {
    const trimmedName = newName.trim();
    if (!trimmedName) return;

    if (trimmedName === currentName) {
      onClose();
      return;
    }

    // Check if name exists
    if (existingNames.includes(trimmedName)) {
      setShowOverwriteConfirm(true);
    } else {
      onRename(trimmedName);
      onClose();
    }
  };

  const handleOverwrite = () => {
    onRename(newName.trim());
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleRename();
    }
  };

  if (showOverwriteConfirm) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
          <h2>Name Exists</h2>
          <p style={{ marginBottom: '20px' }}>
            A configuration named "<strong>{newName.trim()}</strong>" already exists. Overwrite it?
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button onClick={onClose} className="btn">
              Cancel
            </button>
            <button 
              onClick={handleOverwrite} 
              className="btn"
              style={{ background: '#dc3545' }}
            >
              Overwrite
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Rename Configuration</h2>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            New Name:
          </label>
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
            style={{
              width: '100%',
              padding: '8px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              boxSizing: 'border-box'
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} className="btn">
            Cancel
          </button>
          <button 
            onClick={handleRename} 
            className="btn"
            disabled={!newName.trim()}
            style={{
              opacity: newName.trim() ? 1 : 0.5,
              cursor: newName.trim() ? 'pointer' : 'not-allowed'
            }}
          >
            Rename
          </button>
        </div>
      </div>
    </div>
  );
}
